import * as React from 'react'

export const SalesViewerLoader = () => <SalesViewerLoaderAux />

const SalesViewerLoaderAux = () => {
  const [loaded, setLoaded] = React.useState(false)
  React.useEffect((): void => {
    const pathName = window.location.pathname
    if (!loaded && (pathName == salesViewerPage || pathName == `${salesViewerPage}/`)) {
      setLoaded(true)
      loadSalesViewer()
    }
  }, [window.location.pathname])
  return <></>
}

const salesViewerPage = '/de/was-wir-anbieten/portfolio/lohnabf%C3%BCllung'

const loadSalesViewer = (): void => {
  var j = document.createElement('script')
  j.async = true
  j.src = 'https://svrdntfctn.com/stm.js?id=' + 'l2O6h1f4n8e6' + (window['name'] ? '&s=' + window['name'] : '')
  j.referrerPolicy = 'no-referrer-when-downgrade'
  var f = document.getElementsByTagName('script')[0]
  f.parentNode.insertBefore(j, f)
}
